/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type MarketCreated = {
  market: Address;
  oracle: Address;
  quoteMint: Address;
};

export type MarketCreatedArgs = MarketCreated;

export function getMarketCreatedEncoder(): FixedSizeEncoder<MarketCreatedArgs> {
  return getStructEncoder([
    ['market', getAddressEncoder()],
    ['oracle', getAddressEncoder()],
    ['quoteMint', getAddressEncoder()],
  ]);
}

export function getMarketCreatedDecoder(): FixedSizeDecoder<MarketCreated> {
  return getStructDecoder([
    ['market', getAddressDecoder()],
    ['oracle', getAddressDecoder()],
    ['quoteMint', getAddressDecoder()],
  ]);
}

export function getMarketCreatedCodec(): FixedSizeCodec<
  MarketCreatedArgs,
  MarketCreated
> {
  return combineCodec(getMarketCreatedEncoder(), getMarketCreatedDecoder());
}
